import * as React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
// import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
// import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { activitySteps } from "../../utilities/activitySteps";
import family from "../../utilities/images/family.jpeg";

export default function Info() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = activitySteps.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box>
      <Typography marginBottom={2} variant="h4" fontWeight="bold">
        About the Kiddies Crown Contest:
      </Typography>
      <Typography marginBottom={2}>
        Kiddies Crown Contest is a heartwarming initiative designed for Nigerian
        children and their parents. It provides a special opportunity for
        families to showcase their love, affection, and teamwork in a fun and
        exciting way.
      </Typography>
      <Typography marginBottom={2}>
        Organized periodically by Kiddies Crown, a private company dedicated to
        bringing joy to underprivileged children and Nigerian families, the
        contest serves as a platform for kids to shine and compete for
        incredible prizes.
      </Typography>
      <Typography marginBottom={2}>
        Kiddies Crown is a legally registered Nigerian company (RC: 3466345)
        located at Irama Complex, Plot 4, Sa'adu, Zungar Avenue, off Wole
        Soyinka Avenue, 4th Avenue, Gwarinpa, Abuja-FCT. Through initiatives
        like the Kiddies Crown Contest, we aim to strengthen family bonds by
        creating moments of love, unity, and joyful experiences.
      </Typography>

      <Typography variant="h5" fontWeight="bold">
        Here's how it works:
      </Typography>
      <ol>
        <li>
          <span style={{ fontWeight: "bold" }}>Stage 1:</span> Contestants must
          secure at least 300 votes (N50 per vote). All contestants who qualify
          for Stage 2 will receive a courtesy gift pack, delivered to their
          homes nationwide.
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Stage 2:</span> Contestants need
          a minimum of 500 votes to proceed. At this stage, engaging in fun
          activities with parents can earn up to 500 free votes, making paid
          votes optional.
        </li>
        <li>
          <span style={{ fontWeight: "bold" }}>Final Stage:</span> There is no
          set vote requirement. The contestant with the highest votes at the end
          of this stage wins the grand prize. The top 5 contestants will also
          receive amazing consolation prizes.
        </li>
      </ol>
      <Typography marginBottom={2}>
        By hosting this contest, we not only create a joyful experience but also
        give parents a chance to express their deep love for their children in a
        memorable way.
      </Typography>
      <Typography>
        Join us in celebrating love, family, and childhood! ❤️✨
      </Typography>

      <Box>
        <Typography
          textAlign="center"
          variant="h4"
          mt={10}
          fontWeight="fontWeightBold"
        >
          Activity Roadmap:
        </Typography>
        <Paper
          square
          elevation={0}
          sx={{
            display: "flex",
            alignItems: "center",
            height: 50,
            // bgcolor: "background.default",
          }}
        >
          <Typography fontWeight="fontWeightBold">
            {activitySteps[activeStep].label}
          </Typography>
        </Paper>
        <Box sx={{ height: 150, maxWidth: 400, width: "100%" }}>
          {activitySteps[activeStep].description}
        </Box>
        <MobileStepper
          variant="text"
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={activeStep === maxSteps - 1}
            >
              Next
              {theme.direction === "rtl" ? (
                // <KeyboardArrowLeft />
                <p>Left</p>
              ) : (
                // <KeyboardArrowRight />
                <p>Right</p>
              )}
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
            >
              {theme.direction === "rtl" ? (
                // <KeyboardArrowRight />
                <p>Right</p>
              ) : (
                // <KeyboardArrowLeft />
                <p>Left</p>
              )}
              Back
            </Button>
          }
        />
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          marginTop: 1,
        }}
      >
        <img src={family} alt="family" width="400px" />
      </Box>
    </Box>
  );
}
